module.exports = __webpack_public_path__ + "img/logo.50364f5e.png";